import { render, staticRenderFns } from "./TheWarningModal.vue?vue&type=template&id=2bbd9d08&"
import script from "./TheWarningModal.vue?vue&type=script&lang=js&"
export * from "./TheWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports